module.exports = __webpack_public_path__ + "static/media/m_beard_scruff_round__oval.f856b6cd.png";